import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "../api/axios";
import useBrandingLogo from "../hooks/useBrandingLogo";
import "../styles/admin.css";

export default function ForgotPasswordVerify() {
  const location = useLocation();
  const navigate = useNavigate();
  const logoUrl = useBrandingLogo();

  const emailFromState = location.state?.email || "";

  const [email, setEmail] = useState(emailFromState);
  const [otp, setOtp] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!emailFromState) {
      navigate("/forgot-password", { replace: true });
    }
  }, [emailFromState, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");

    try {
      setSubmitting(true);

      const cleanEmail = String(email || "").trim().toLowerCase();
      const cleanOtp = String(otp || "").trim();

      const res = await api.post("/auth/forgot-password/verify-otp", {
        email: cleanEmail,
        otp: cleanOtp,
      });

      setMsg(res?.data?.message || "Recovery OTP verified successfully.");

      navigate("/reset-password", {
        replace: true,
        state: {
          email: cleanEmail,
          otp: cleanOtp,
        },
      });
    } catch (err) {
      console.error("Forgot password verify OTP error:", err?.response?.data?.message || err.message);
      setError(err?.response?.data?.message || "Failed to verify OTP.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="admin-login-page">
      <section className="admin-forgot-shell">
        <div className="admin-forgot-card">
          <img
            src={logoUrl}
            alt="FleetX Logo"
            className="admin-forgot-logo"
          />

          <p className="admin-login-form__eyebrow">Password Recovery</p>
          <h1 className="admin-forgot-title">Verify Recovery OTP</h1>
          <p className="admin-forgot-subtitle">
            Enter the 6-digit OTP sent to your admin email address.
          </p>

          <form onSubmit={handleSubmit} className="admin-login-form">
            <label className="admin-login-label">Email Address</label>
            <div className="admin-login-inputWrap">
              <span className="admin-login-inputIcon">✉</span>
              <input
                className="admin-login-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>

            <label className="admin-login-label">Recovery OTP</label>
            <div className="admin-login-inputWrap">
              <span className="admin-login-inputIcon">#</span>
              <input
                className="admin-login-input"
                type="text"
                placeholder="Enter 6-digit OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                inputMode="numeric"
                maxLength={6}
                required
              />
            </div>

            <button
              type="submit"
              className="admin-login-button"
              disabled={submitting}
            >
              {submitting ? "Verifying..." : "Verify OTP"}
            </button>
          </form>

          {msg ? <p className="admin-forgot-success">{msg}</p> : null}
          {error ? <p className="admin-login-error">{error}</p> : null}

          <Link to="/forgot-password" className="admin-forgot-back">
            ← Back to Forgot Password
          </Link>
        </div>
      </section>
    </main>
  );
}
